import { apiPost, generateFormData } from '../../../modules/apiHelper';
import resolve from '../../../modules/api/resolve';

export default {
  async getProgramContents(context, programId) {
    const [active, deactivated] = await Promise.all([
      resolve(apiPost('ema_content_list', generateFormData({
        progid: programId,
      }), 92)),
      resolve(apiPost('ema_dev_content_list', generateFormData({
        progid: programId,
      }), 92)),
    ]);

    if (!active || !deactivated) return false;

    return {
      active: active.ema_content_list,
      deactivated: deactivated.ema_dev_content_list,
    };
  },

  async getProgramContentResources(context, programContentId) {
    const [active, deactivated] = await Promise.all([
      resolve(apiPost('content_resources_list', generateFormData({
        contentid: programContentId,
      }), 92)),
      resolve(apiPost('dev_content_resources_list', generateFormData({
        contentid: programContentId,
      }), 92)),
    ]);

    if (!active || !deactivated) return false;

    return {
      active: active.content_resources_list,
      deactivated: deactivated.dev_content_resources_list,
    };
  },

  async createProgramContent(context, data) {
    const formData = generateFormData(data);
    formData.set('progid', data.programId);

    const response = await resolve(apiPost('create_ema_prog_content', formData, 92));

    return response;
  },

  async createProgramContentResource(context, data) {
    const senderid = context.rootState.User.id;

    const formData = generateFormData(data);
    formData.set('senderid', senderid);
    formData.append('file1', data.file);

    const response = await resolve(apiPost('create_ema_prog_content_resources', formData, 92));

    return response;
  },

  async activateProgramContent(context, programContentId) {
    const response = await resolve(apiPost('act_ema_prog_content', generateFormData({
      contentid: programContentId,
    }), 92));

    return response;
  },

  async deactivateProgramContent(context, programContentId) {
    const response = await resolve(apiPost('dev_ema_prog_content', generateFormData({
      contentid: programContentId,
    }), 92));

    return response;
  },

  async activateProgramContentResource(context, resourceId) {
    const response = await resolve(apiPost('act_content_resource', generateFormData({
      resourceid: resourceId,
    }), 92));

    return response;
  },

  async deactivateProgramContentResource(context, resourceId) {
    const response = await resolve(apiPost('dev_content_resource', generateFormData({
      resourceid: resourceId,
    }), 92));

    return response;
  },

  async updateProgramContent(context, data) {
    const response = await Promise.all([
      resolve(apiPost('edit_ema_prog_content', generateFormData(data), 92)),
      resolve(apiPost('edit_ema_prog_content_desc', generateFormData(data), 92)),
    ]);

    return response.every(Boolean);
  },
};
